import { lightColors, darkColors } from "@common/consts/colors";

if (typeof window !== "undefined") {
  // add colors to document
  Object.entries(lightColors).forEach(([color, hex]) => {
    document.documentElement.style.setProperty(`--light-color-${color}`, hex);
  });

  Object.entries(darkColors).forEach(([color, hex]) => {
    document.documentElement.style.setProperty(`--dark-color-${color}`, hex);
  });
}
